export const initialState = () => ({
  password: {},
  timeInactive: 0,
});

const state = initialState();

export default state;
